import getConfig from "next/config"
import { Image, Row } from "antd"
import AddOnPurchase from "@/components/AddOnPurchase"
import styles from "@/styles/view-cart.module.scss"

const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

const paymentLogoList = [
  {
    title: 'PayPal',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-paypal-Color.svg',
  }, {
    title: 'visa',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-visa-Color.svg',
  }, {
    title: 'Master',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-Master-Color.svg',
  }, {
    title: 'Bpay',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-Bpay-Color.svg',
  }, {
    title: 'AMEX',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-AMEX-Color.svg',
  }, {
    title: 'zip',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-zip-Color.svg',
  }, {
    title: 'afterpay',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-afterpay-Color.svg',
  }, {
    title: 'applePay',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-ApplePay-Color.svg',
  }, {
    title: 'googlepay',
    imageUrl: 'https://img.crazysales.com.au/images/2022v/img/pay/icon-payment-logo-GooglePay-Color.svg',
  }
]

interface PaymentTrustFooterProps {
  onAddOnSuccess?: () => void
  totalAmount?: number | string
}

const PaymentTrustFooter = ({ onAddOnSuccess, totalAmount }: PaymentTrustFooterProps) => (
  <div className={styles['viewcar-footer']}>
    <div className={styles["left"]}>
      <div className={styles['title']}>
        We Proudly Accept:
      </div>
      <Row align="middle">
        {
          paymentLogoList.map(item =>
            <span className={styles['paymentLogoItem']} key={item.imageUrl + item.title}>
              <Image
                key={item.imageUrl}
                className={styles['payment-item']}
                alt={item.title}
                height={'100%'}
                preview={false}
                src={item.imageUrl}
              />
            </span>
          )
        }
      </Row>
      <div className={styles['payment-privacy']}>
        <Image alt="" src={`${imageDomain}/checkout/norton.png`} height="48px" preview={false} />
        <Image alt="" src={`${imageDomain}/checkout/compdp.png`} height="48px" preview={false} />
        <Image alt="" src={`${imageDomain}/checkout/lock.png`} height="48px" preview={false} />
        <div className={styles['privacy']}>
          Your payment details are protected and
          encrypted by 256-bit SSL technology.
          Your privacy and security is guaranteed.
        </div>
      </div>
    </div>

    <div className={styles['recommend-goods']}>
      <AddOnPurchase
        onAddOnSuccess={onAddOnSuccess}
        refreshKey={totalAmount}
        refreshOnAddSuccess={false}
      />
    </div>
  </div>
)

export default PaymentTrustFooter
